/*
 * Product specs (loaded on every product page by sections/product-specs.liquid).
 *
 * 1. Variant panes: show the selected variant's pane (chips, Dimensions, Assembly, Packaging,
 *    What's included, the Origin row). The panes are server-rendered by
 *    snippets/modus-specs-*.liquid with data-modus-variant-pane="<variant id>"; this only
 *    toggles their hidden attribute. Scoped by product id so a quickshop for another product
 *    on the same page does not touch these specs.
 * 2. Care text: the Care accordion holds one placeholder per material
 *    (data-modus-care-key="<section key on the care page>"). On its first open, fetch the care
 *    page, copy only those sections' text (heading + rich text, no image) into the
 *    placeholders, then hide the fallback link. If the fetch fails the link stays.
 */
(function () {
  // ---------- 1. Variant panes ----------
  function sync(productId, variantId) {
    var roots = document.querySelectorAll('[data-modus-specs][data-product-id="' + productId + '"]');
    for (var i = 0; i < roots.length; i++) {
      var panes = roots[i].querySelectorAll('[data-modus-variant-pane]');
      for (var j = 0; j < panes.length; j++) {
        panes[j].hidden = panes[j].getAttribute('data-modus-variant-pane') !== String(variantId);
      }
    }
  }

  // Empire dispatches variant-change on <variant-selection> without bubbles (empire.js:366);
  // a capture-phase listener on document still receives it.
  document.addEventListener('variant-change', function (e) {
    var d = e.detail || {};
    if (!d.variant || !d.product) return; // not-selected / unavailable: keep the last values
    sync(d.product.id, d.variant.id);
  }, true);

  // ---------- 2. Care text ----------
  // Copy text nodes and line breaks only; every other element is flattened to its text.
  function copyText(from, to) {
    for (var n = from.firstChild; n; n = n.nextSibling) {
      if (n.nodeType === 3) {
        to.appendChild(document.createTextNode(n.nodeValue));
      } else if (n.nodeType === 1) {
        if (n.tagName === 'BR') {
          to.appendChild(document.createElement('br'));
        } else {
          copyText(n, to);
        }
      }
    }
  }

  // sec = one rendered dynamic-image-with-text section (.image-with-text__heading / __text).
  // A slot with data-modus-care-code (the cleaning-codes section) takes only the paragraph whose
  // bold lead matches that code ("SW: Clean with ...") and keeps its own heading.
  function fillCare(slot, sec) {
    var text = sec.querySelector('.image-with-text__text');
    if (!text) return;
    var code = (slot.getAttribute('data-modus-care-code') || '').toUpperCase();
    var heading = sec.querySelector('.image-with-text__heading');
    var h = slot.querySelector('h4');
    if (!code && heading && h && heading.textContent.trim()) h.textContent = heading.textContent.trim();
    var blocks = text.querySelectorAll('p');
    if (!blocks.length) blocks = [text];
    var added = 0;
    for (var i = 0; i < blocks.length; i++) {
      if (code) {
        var lead = blocks[i].querySelector('strong');
        if (!lead || lead.textContent.trim().toUpperCase() !== code) continue;
      }
      var p = document.createElement('p');
      copyText(blocks[i], p);
      if (/\S/.test(p.textContent)) {
        slot.appendChild(p);
        added++;
      }
    }
    if (added) slot.setAttribute('data-modus-care-loaded', '');
  }

  function loadCare(details) {
    if (details.hasAttribute('data-modus-care-started')) return;
    details.setAttribute('data-modus-care-started', '');
    if (!window.fetch || !window.DOMParser) return;

    var slots = details.querySelectorAll('[data-modus-care-key]');
    if (!slots.length) return;

    // The Section Rendering API wants the full section id (template--<template id>__<key>)
    // and returns null for the bare key; the template id differs per theme. So fetch the care
    // page once and pick each section by the key its DOM id ends with.
    var url = details.getAttribute('data-modus-care-url') || '/pages/product-care';
    fetch(url, { credentials: 'same-origin' })
      .then(function (r) {
        if (!r.ok) throw new Error('HTTP ' + r.status);
        return r.text();
      })
      .then(function (html) {
        var doc = new DOMParser().parseFromString(html, 'text/html');
        for (var j = 0; j < slots.length; j++) {
          var sec = doc.querySelector('[id$="__' + slots[j].getAttribute('data-modus-care-key') + '"]');
          if (sec) fillCare(slots[j], sec);
        }
        if (details.querySelector('[data-modus-care-key]:not([data-modus-care-loaded])')) return;
        var links = details.querySelectorAll('[data-modus-care-fallback]');
        for (var m = 0; m < links.length; m++) links[m].hidden = true;
      })
      .then(null, function () { /* keep the fallback link */ });
  }

  var cares = document.querySelectorAll('[data-modus-care]');
  for (var c = 0; c < cares.length; c++) {
    (function (details) {
      if (details.open) {
        loadCare(details);
        return;
      }
      details.addEventListener('toggle', function onToggle() {
        if (!details.open) return;
        details.removeEventListener('toggle', onToggle);
        loadCare(details);
      });
    })(cares[c]);
  }
})();
